import { createApp } from 'vue'
import App from './App.vue'

// Check if devtools should be allowed based on query string or development mode
const urlParams = new URLSearchParams(window.location.search)
const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === '5173.cuanapps.com' || window.location.hostname === '5173.cuanapps.com'
const allowDevtools = urlParams.has('devtools') || isDev

if (!allowDevtools) {
  // The disable-devtool functionality is now handled by the script tag in index.html
  console.log('Devtools protection is active')
}

createApp(App).mount('#app') 